module.exports = __webpack_public_path__ + "img/logo-blue.0f03af6c.svg";